import { avatarDimension } from 'utils/files/fileTransformations'

import { Media, MediaCrop } from 'types/media'

export const baseCrop: MediaCrop = {
  aspect: 1,
  height: 250,
  width: 250,
  x: 0,
  y: 0,
  unit: 'px',
}

export const defaultAvatarImage: Media = {
  crop: baseCrop,
  dimensions: {
    width: avatarDimension,
    height: avatarDimension,
  },
  mimeType: 'image/png',
  url: 'https://res.cloudinary.com/upswingfitness-prod/image/upload/images/avatars/default.png',
  _original: {},
}
